module.exports = __webpack_public_path__ + "img/Notifications.23de6142.svg";